/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
function navigateBack(params, context) {
    var api = 'dd.biz.navigation.close';
    context === null || context === void 0 ? void 0 : context.DDCall(api, params);
}

export { navigateBack as default };
